export enum Roles {
    Admin = 'Administrator',
    Dispatcher = 'Dispatcher',
    Driver = 'Driver'
}